// extracted by mini-css-extract-plugin
module.exports = {"banner":"F_cy","icon":"F_bj","title":"F_bs","text":"F_cz","button":"F_ch"};